import React from "react";
import Socialmedia from "./Socialmedia";

const Contact=()=>
{
    return(
        <>
        <Socialmedia/>
        </>
    )
}

export default Contact;